import sharing from "./../templates/sharing.dust";

import language from "./../dictionary";

import { generateSecurePreviewURL } from "./../utilities/utils";

import {
  CLICKED_FACEBOOK_SHARE,
  CLICKED_MAIL_SHARE,
  CLICKED_GOOGLE_SHARE,
  CLICKED_TWITTER_SHARE,
  CLICKED_PRINT_ALB,
  CLICKED_PRINT_TEXT_ALB,
  CLICKED_PRINT_IMAGE_ALB,
  CLICKED_WHATSAPP_SHARE,
} from "./../analytics/analyticsevents";

export default class SharingComponent {
  appState;
  sharingUrls;
  options;
  DOMContainer;
  body;
  constructor(appState, sharingUrls, DOMContainer, options = {}, eventName) {
    this.appState = appState;
    this.sharingUrls = sharingUrls;
    this.options = options;
    this.DOMContainer = DOMContainer;
    this.sharingEventName = eventName;
    this.body = document.getElementsByTagName("BODY")[0];
    this.render();
  }

  close(e, force) {
    if (this.rendered) {
      const print = this.DOMContainer.querySelector(".sharing-item.print");
      if (
        force ||
        !print ||
        (print !== e.target && !$.contains(print, e.target))
      ) {
        this.DOMContainer.classList.add("hidden");
        return true;
      }
    }
    return false;
  }

  render() {
    if (this.DOMContainer) {
      const context = {};
      context.sharing = this.sharingUrls;
      context.print = this.options.printArticle;
      context.image = language.printImage;
      context.text = language.printText;
      context.print = language.print;
      Dust.render(sharing, context, (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.attatchClickHandlers();
        this.rendered = true;
        this.appState.triggerEvent(this.sharingEventName);
        if (context.print && !context.sharing) {
          this.appState.triggerEvent(CLICKED_PRINT_ALB);
        }
      });
    }
  }

  attatchClickHandlers() {
    const shareItems = this.DOMContainer.querySelectorAll(".sharing-item");
    shareItems.forEach((item) => {
      const share = item.getAttribute("data-share");
      const id = item.getAttribute("data-id");
      let url = null;
      if (this.sharingUrls && id) {
        url = this.sharingUrls[parseInt(id, 10)];
      }
      item.addEventListener("click", () => {
        switch (share) {
          case "Facebook":
            this.appState.triggerEvent(CLICKED_FACEBOOK_SHARE);
            if (url) {
              window.open(url.url);
            }
            break;
          case "WhatsApp":
            this.appState.triggerEvent(CLICKED_WHATSAPP_SHARE);
            if (url) {
              window.open(url.url);
            }
            break;
          case "GooglePlus":
            this.appState.triggerEvent(CLICKED_GOOGLE_SHARE);
            if (url) {
              window.open(url.url);
            }
            break;
          case "Twitter":
            this.appState.triggerEvent(CLICKED_TWITTER_SHARE);
            if (url) {
              window.open(url.url);
            }
            break;
          case "Mail":
            this.appState.triggerEvent(CLICKED_MAIL_SHARE);
            if (url) {
              window.location.href = url.url;
            }
            break;
          case "print":
            this.openPrint();
            break;
          case "print-image":
            this.printImage();
            break;
          case "print-text":
            this.printText();
            break;
          default:
        }
      });
    });
  }

  openPrint() {
    const printItems = this.DOMContainer.querySelector(".print-items");
    if (printItems) {
      printItems.classList.toggle("hidden");
      this.appState.triggerEvent(CLICKED_PRINT_ALB);
    }
  }

  printImage() {
    const click = document.querySelectorAll(
      `.swiper-slide-page-click-container .swiper-slide-page-click[data-contentID="${this.appState.contentid}"]`
    );
    //This will help us create styling specific to text and image printing.
    if (this.body.classList.contains("textPrinting")) {
      this.body.classList.remove("textPrinting");
    }
    if (!this.body.classList.contains("imagePrinting")) {
      this.body.classList.add("imagePrinting");
    }
    const printing = document.querySelector("#printing");
    printing.innerHTML = "";
    const container = document.createElement("div");
    container.classList.add("canvas-container");
    printing.appendChild(container);
    let promises = [];
    if (click && click.length > 0) {
      for (let i = 0; i < click.length; i++) {
        const { userId, sessionId, downloadId } = this.appState;
        const url = generateSecurePreviewURL(
          this.options.printSize,
          click[i].getAttribute("data-pageid"),
          sessionId,
          userId,
          downloadId
        );
        const top = parseFloat(click[i].style.top) / 100;
        const left = parseFloat(click[i].style.left) / 100;
        const width = parseFloat(click[i].style.width) / 100;
        const height = parseFloat(click[i].style.height) / 100;
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        var img = new Image();
        container.appendChild(canvas);
        promises.push(
          this.loadImage(img, top, left, width, height, canvas, ctx)
        );
        img.src = url;
      }

      Promise.all(promises)
        .then(() => {
          if (typeof window.print === "function") {
            window.print();
          }
        })
        .finally(() => {
          this.body.classList.remove("imagePrinting");
        });
    }
    this.appState.triggerEvent(CLICKED_PRINT_IMAGE_ALB);
  }

  loadImage(img, top, left, width, height, canvas, ctx) {
    return new Promise((resolve, reject) => {
      img.onload = () => {
        const margin = this.options.printExtraMargin;
        const marginLeft = this.options.printMarginLeft;
        const w = img.width;
        const h = img.height;
        const sx = w * left - marginLeft;
        const sy = h * top - marginLeft;
        const sw = w * width + margin * 2;
        const sh = h * height + margin * 2;
        canvas.width = sw;
        canvas.height = sh;
        const dw = sw;
        const dh = sh;
        ctx.drawImage(img, sx, sy, sw, sh, 0, 0, dw, dh);
        resolve();
      };
      img.onerror = () => {
        reject();
      };
    });
  }

  printText() {
    const printing = document.querySelector("#printing");
    const slide = document.querySelector(
      ".swiper-slide-active .alb-content-scroll"
    );
    const container = document.createElement("div");
    printing.innerHTML = "";
    if (!this.body.classList.contains("textPrinting")) {
      this.body.classList.add("textPrinting");
    }
    container.classList.add("swiper-container-alb");
    container.innerHTML = slide.innerHTML;
    printing.appendChild(container);
    if (typeof window.print === "function") {
      setTimeout(() => {
        window.print();
        printing.innerHTML = "";
        this.body.classList.remove("textPrinting");
      }, 250); // To give the image more time to load before the page can be printed
    }
    this.appState.triggerEvent(CLICKED_PRINT_TEXT_ALB);
  }

  printArticleImage() {}
}



// WEBPACK FOOTER //
// ./src/common/components/sharingComponent.js